import { faInfoCircle, faThumbsDown, faThumbsUp, faWarning } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import VoxelAlert from '../../components/voxel/Alert/VoxelAlert';
import VoxelChip from '../../components/voxel/Chips/VoxelChip';
import VoxelText from '../../components/voxel/Text/VoxelText';

export interface StatusBoardProps { }

export const StatusBoard: React.FC<StatusBoardProps> = ({ }) => {
  return (
    <>
      <div className="flex flex-col gap-8">
        <VoxelText variant="title2">Chips</VoxelText>
        <div className="flex flex-row items-center gap-2">
          <VoxelChip color="neutral" title={'Neutral'} close />
          <VoxelChip
            color="success"
            title={'Success'}
            icon={<FontAwesomeIcon icon={faThumbsUp} />}
            close
          />
          <VoxelChip
            color="error"
            title={'Error'}
            icon={<FontAwesomeIcon icon={faThumbsDown} />}
            close
          />
          <VoxelChip
            color="info"
            title={'Info'}
            icon={<FontAwesomeIcon icon={faInfoCircle} />}
            close
          />
          <VoxelChip
            color="warning"
            title={'Warning'}
            icon={<FontAwesomeIcon icon={faWarning} />}
            close
          />
        </div>

      </div>
      <VoxelText variant="title2">Alerts</VoxelText>
      <div className="flex flex-col gap-y-2">
        <VoxelAlert title="Error alert" severity="error" hideClose={false} size='sm'>
          Some text about the alert
        </VoxelAlert>
        <VoxelAlert title="Warning alert" severity="warning" hideClose={false} size='sm'>
          Some text about the alert
        </VoxelAlert>
        <VoxelAlert title="Info alert" severity="info" hideClose={false} size='sm'>
          Some text about the alert
        </VoxelAlert>
        <VoxelAlert title="Success alert" severity="success" hideClose={false} size='sm'>
          Some text about the alert
        </VoxelAlert>
      </div>
      <div className="flex flex-col gap-y-2">
        <VoxelAlert title="Error alert" severity="error" onClickTitle={'Do action'}>
          Some text about the alert
        </VoxelAlert>
        <VoxelAlert title="Warning alert" severity="warning" onClickTitle={'Do action'}>
          Some text about the alert
        </VoxelAlert>
        <VoxelAlert title="Info alert" severity="info" onClickTitle={'Do action'}>
          Some text about the alert
        </VoxelAlert>
        <VoxelAlert title="Success alert" severity="success" onClickTitle={'Do action'} >
          Some text about the alert
        </VoxelAlert>
      </div>

    </>
  );
};

export default StatusBoard;
